<template>
    <div>
        <el-row :gutter="40" style="margin-top:100px">
            <el-col :span="6"  :offset="2">
                <el-button type="primary" class="bt" icon="el-icon-switch-button" @click="closeComputer">设备关机</el-button>
            </el-col>
            <el-col :span="6">
                <el-button type="success" class="bt" icon="el-icon-circle-close" @click="closeClient">关闭软件</el-button>
            </el-col>
            <el-col :span="6">
                <el-button type="danger" class="bt" icon="el-icon-lock" @click="servicePage">维护界面</el-button>
            </el-col>
        </el-row>
        <el-row :gutter="40">
            <el-col :span="6" :offset="2">
                <el-button type="info" class="bt" icon="el-icon-receiving" @click="unlockScanner">弹出扫描仪</el-button>
            </el-col>
            <el-col :span="6">
                <el-button type="warning" class="bt" icon="el-icon-wallet" @click="ejectFile">弹出托盘</el-button>
            </el-col>
            <el-col :span="6">
                <el-button type="primary" class="bt" icon="el-icon-files" @click="receiveTicket">管理员取单</el-button>
            </el-col>
        </el-row>
        <el-row :gutter="40">
            <el-col :span="6" :offset="2">
                <el-button type="success" class="bt" icon="el-icon-receiving" @click="resetIst">收票模块状态重置</el-button>
            </el-col>
            <el-col :span="6">
                <el-button type="info" class="bt" icon="el-icon-receiving" @click="playSound">{{openSound ? '关闭宣传片声音' : '播放宣传片声音'}}</el-button>
            </el-col>
            <el-col :span="6">
                <el-button type="warning" class="bt" icon="el-icon-printer" @click="printForm">打印自制表单</el-button>
            </el-col>
        </el-row>

        <!-- 弹出扫描仪 -->
        <el-dialog style="margin-top:30vh;"
            :visible.sync="msgDialogVisible"
            width="30%"
            center 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :show-close="false">
            <span slot="title">
                提示信息
            </span>
            <div style="text-align:center;font-size:1rem;">清除卡纸后请将扫描仪推回设备内</div>
            <span slot="footer" class="dialog-footer">

            </span>
        </el-dialog>

        <!-- 弹出托盘 -->
        <el-dialog style="margin-top:30vh;"
            title="提示信息"
            :visible.sync="restoreDialogVisible"
            width="30%"
            center 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :show-close="false">
            <div style="text-align:center;font-size:1rem;" v-html="restoreDishMsg">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="restore">收回托盘</el-button>
            </span>
        </el-dialog>
        <!-- 托盘弹出中 -->
        <el-dialog style="margin-top:30vh;"
            title="提示信息"
            :visible.sync="restoreLoadingDialogVisible"
            width="30%"
            center 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :show-close="false">
            <div style="text-align:center;font-size:1rem;">
                托盘正在弹出，请稍后...
            </div>
        </el-dialog>

        <!-- 升降台下降 -->
        <el-dialog style="margin-top:30vh;"
            title="提示信息"
            :visible.sync="platformDialogVisible"
            width="30%"
            center 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :show-close="false">
            <div style="text-align:center;font-size:1rem;">
                {{platformText}}
            </div>
            <span v-if="!platformLoading" slot="footer" class="dialog-footer">
                <el-button type="primary" @click="trayUp">升降台上升</el-button>
            </span>
        </el-dialog>

        <!-- 收票模块复位 -->
        <el-dialog style="margin-top:30vh;"
            :visible.sync="istDialogVisible"
            width="30%"
            center 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :show-close="false">
            <span slot="title">
                提示信息
            </span>
            <div style="text-align:center;font-size:1rem;">收票模块重置中,请稍等</div>
            <span slot="footer" class="dialog-footer">

            </span>
        </el-dialog>

        <!-- 关闭闸门有异物 -->
        <el-dialog style="margin-top:30vh;"
            title="提示信息"
            :visible.sync="gateExceptionDialogVisible"
            width="30%"
            center 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :show-close="false">
            <div style="text-align:center;font-size:1rem;">
                {{ gateMsg }}
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeGate" v-show="gateBtn">关闭闸门</el-button>
            </span>
        </el-dialog>

        <homeBtn @goHome="goHome" ref="homeBtn"></homeBtn>
    </div>
</template>

<script>
import homeBtn from '@/components/homeButton'
import { MessageBox } from 'element-ui';
export default {
    name: "waiting",
    components: {                
        homeBtn
    },
    data() {
        return {
            deviceNo: null, // 设备编号
            messageModel: undefined,
            msgDialogVisible: false,
            restoreDialogVisible: false,
            restoreLoadingDialogVisible: false,
            restoreDishMsg: '取出全部原始凭证后，请收回托盘',
            platformDialogVisible: false,
            istDialogVisible: false,
            gateExceptionDialogVisible: false,
            checkScannerLocationTimer: undefined,
            gateMsg: '闸门处有异物,请清理后再次点击关闭闸门',
            gateBtn: true,
            platformText: '将文件取走后,点击升降台上升',
            platformLoading: true,
            openSound: 0 // 设置宣传片声音
        }
    },
    mounted(){
        let deviceNo = this.myStore.state.deviceNo;
        this.deviceNo = deviceNo
    },
    destroyed () {
        if(typeof(this.messageModel) !== "undefined") {
            this.messageModel.close();
        }
        if(typeof(this.checkScannerLocationTimer) !== "undefined") {
            clearTimeout(this.checkScannerLocationTimer);
        }
    },
    methods: {
        async goHome() {
            if(this.platformDialogVisible){
                let message = '纸仓未复位，将重置收票模块'
                this.$alert(message, '设备异常', {
                    type: 'warning',
                    showClose: false,
                    showCancelButton: false,
                    confirmButtonText: '确定',
                    callback: async action => {
                        this.istDialogVisible = true;
                        await this.resetDevice();
                        this.istDialogVisible = false;
                        this.$router.push({ path: this.myStore.state.mainUrl });
                    }
                }); 
            }else {
                this.$router.push({ path: this.myStore.state.mainUrl }); 
            }             
        },
        closeClient() {
            window.close();
            this.videoWindow.close()
        },
        closeComputer() {
            this.sys.shutdown();
        },
        servicePage() {
            this.$router.push({ path: '/boaccount/servicePage' });
        },
        async unlockScanner() {
            this.msgDialogVisible = true;

            let result = await this.ist.call("unlock");
            console.log("unlock:" + JSON.stringify(result));
            if(result.result == 0){
				console.log("弹出扫描仪成功");
                this.startCheckScannerLocationTimer();
			} else {
                this.msgDialogVisible = false;
                console.error("弹出扫描仪发生错误:" + result.message);
                let message = '弹出扫描仪发生未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
			}
        },
        async startCheckScannerLocationTimer() {
            let result = await this.ist.call("get_sensor_status");
            console.log("get_sensor_status:" + JSON.stringify(result));
            if(result.result == 0) {
                let sensor = result.sensor;
                let scannerLocationSensor = sensor.sensor17;
                if(scannerLocationSensor == 0) { //扫描仪已归位
                    await this.resetDevice();
                    this.msgDialogVisible = false;
                } else { //扫描仪未归位
                    this.checkScannerLocationTimer = setTimeout(() => {
                        this.startCheckScannerLocationTimer();
                    }, 500);
                }
            } else {
                this.msgDialogVisible = false;
                console.error("获取收票模块传感器发生错误:" + result.message);
                let message = '获取收票模块传感器未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }
        },
        async resetDevice() {
            let result = await this.ist.resetDevice();
            console.log("resetDevice:" + JSON.stringify(result));
            if(result.result == 0) {
                console.log("重置收票模块成功");
                if(typeof(this.messageModel) !== "undefined") {
                    this.messageModel.close();
                }
            } else {
                console.error("重置收票模块发生错误:" +  + result.message);
                let message = '重置收票模块发生未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }
        },
        async ejectFile() {
            
            this.restoreLoadingDialogVisible = true
            let result = await this.ist.call("eject");
            console.log("eject:" + JSON.stringify(result));
            if(result.result == 0) {
                console.log("退出文件成功");
                this.restoreDialogVisible = true;
                this.restoreLoadingDialogVisible = false
                this.$emit('ControlLight', 'eject_light', '500');
            } else {
                this.restoreLoadingDialogVisible = false
                console.error("退出文件发生错误:" + result.message);
                let message = '退出文件发生未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }
        },
        async restore() {
            let result = await this.ist.call("restore");
            console.log("restore:" + JSON.stringify(result));
            this.restoreDialogVisible = false;
            if(result.result == 0) {
                console.log("收回托盘成功");
                this.$emit('ControlLight', 'eject_light', '0');
            } else if (result.result == -6) { //闸门关闭超时
                console.error("收回托盘发生错误:" + result.message);
                let message = '收回托盘发生未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            } else if (result.result == -7) { //闸门出口有异物
                this.gateExceptionDialogVisible = true;
            } else {
                console.error("收回托盘发生错误:" + result.message);
                let message = '收回托盘发生未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }
        },
        async closeGate() {
            this.gateMsg =  '正在关闭关闸,请稍等';
            this.gateBtn = false;

            let result = await this.ist.resetDevice();
            console.log("resetDevice:" + JSON.stringify(result));
            if(result.result == 0) {
                console.log("关闭闸门成功");
                this.gateExceptionDialogVisible = false;
                this.$emit('ControlLight', 'eject_light', '0');
            } else if (result.result == -6) { //闸门关闭超时
                console.error("关闭闸门发生错误:" + result.message);
                this.gateExceptionDialogVisible = false;
                let message = '关闭闸门发生未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            } else if (result.result == -7) { //闸门出口有异物
                this.gateMsg = '闸门处有异物,请清理后再次点击关闭闸门';
                this.gateBtn = true;
            } else {
                console.error("关闭闸门发生错误:" +  + result.message);
                this.gateExceptionDialogVisible = false;
                let message = '关闭闸门发生未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }
        },
        // 纸仓下降
        async receiveTicket() {
            let paperBinDoorOpen = false;
            let siuResult = await this.siu.getInput();
            console.log("siu_getInput:" + JSON.stringify(siuResult));
            //{ "input" : [ { "port" : "paper_bin_door", "value" : 1 } ], "message":"","resu1t" :0, "device”:"siu" }
            if(siuResult.result == 0) {
                let inputList = siuResult.input;
                for(let i = 0; i < inputList.length; i++) {
                    let inputObj = inputList[i];
                    if(inputObj.port == 'paper_bin_door') { //纸仓门传感器
                        let inputValue = inputObj.value;
                        if(inputValue == 1) { //纸仓门处于打开状态
                            paperBinDoorOpen = true;
                        }
                    }
                }
                if(paperBinDoorOpen) { //纸仓门处于打开状态
                    this.$alert('纸仓门未关闭，请先关闭纸仓门，再操作', '设备异常', {
                        type: 'warning',
                        showClose: false,
                        showCancelButton: false,
                        confirmButtonText: '确定',
                        callback: async action => {
                            console.log('action', action)
                        }
                    });
                    return ;
                }
            } else {
                let message = '智能电源故障，请维修'
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }

            this.platformText = '升降台下降中，请稍后...'
            this.platformDialogVisible = true;
            this.platformLoading = true

            let result = await this.ist.call("tray_down");
			console.log("tray_down:" + JSON.stringify(result));
			if(result.result == 0){
				console.log("升降台下降成功");
                this.platformText = '将文件取走后,点击升降台上升'
                this.platformLoading = false
			}else{
                this.platformDialogVisible = false;
                console.error("升降台下降发生错误:" + result.message);
                let message = '升降台下降发生未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
			}
        },
        // 纸仓上升
        async trayUp() {
            let paperBinDoorOpen = false;
            let siuResult = await this.siu.getInput();
            console.log("siu_getInput:" + JSON.stringify(siuResult));
            //{ "input" : [ { "port" : "paper_bin_door", "value" : 1 } ], "message":"","resu1t" :0, "device”:"siu" }
            if(siuResult.result == 0) {
                let inputList = siuResult.input;
                for(let i = 0; i < inputList.length; i++) {
                    let inputObj = inputList[i];
                    if(inputObj.port == 'paper_bin_door') { //纸仓门传感器
                        let inputValue = inputObj.value;
                        if(inputValue == 1) { //纸仓门处于打开状态
                            paperBinDoorOpen = true;
                        }
                    }
                }
                if(paperBinDoorOpen) { //纸仓门处于打开状态
                    this.$alert('纸仓门未关闭，请先关闭纸仓门，再操作', '设备异常', {
                        type: 'warning',
                        showClose: false,
                        showCancelButton: false,
                        confirmButtonText: '确定',
                        callback: async action => {
                            console.log('action', action)
                        }
                    });
                    return ;
                }
            } else {

                let message = '智能电源故障，请维修'
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
            }

            this.platformDialogVisible = false;

            let result = await this.ist.call("tray_up");
			console.log("tray_up:" + JSON.stringify(result));
			if(result.result == 0){
				console.log("升降台上升成功");
			} else {
                console.error("升降台上升发生错误:" + result.message);
                let message = '升降台上升发生未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                this.$alert(message, '设备故障', {
                    showCancelButton: false,
                    showConfirmButton: false
                });
			}
        },
        // 重置收票模块
        async resetIst() {
           this.istDialogVisible = true;
           await this.resetDevice();
           this.istDialogVisible = false;
        },
        // 播放宣传片声音
        playSound(){
            if(!this.openSound){
                this.openSound = 1
                this.videoWindow.postMessage('openSound', '*')
            }else {
                this.openSound = 0
                this.videoWindow.postMessage('closeSound', '*')
            }
            
        },
        // 打开自制表单
        printForm(){
            window.open('https://finance.jobroute.net:8086/#/index?town=notType')
        }
    }
}
</script>

<style scoped>
    @import "~@/assets/css/buttons/buttons.css";

    .bt {
        cursor: pointer;
        transition: all 0.3s ease-out;
        width: 300px;
        height: 170px;
        margin-top: 30px;
        border-radius: 5px;
        text-align: center;
        font-size: 1.8rem;
        color:white
    }
    .bt:active {
        background-image: none;
        -webkit-transform: scale(0.95);
        -ms-transform: scale(0.95);
        transform: scale(0.95);
    }
</style>